import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['table', 'tableContainer', 'scrollLeft', 'scrollRight']
  static values = {
    scrollDistance: { type: Number, default: 450 },
    scrollSpeed: { type: Number, default: 250 },
  }

  scrollLeft() {
    this.#scrollTable(-1)
  }

  scrollRight() {
    this.#scrollTable(1)
  }

  tableContainerTargetConnected() {
    $(this.tableTarget).DataTable(
      {
        fixedColumns: true,
        fixedHeader: true,
        paging: false,
        processing: false,
        scrollX: true,
        scrollY: '500px',
        searching: false,
      },
    )
  }

  #scrollTable(direction) {
    const scrollable = $(this.element.querySelector('.dataTables_scrollBody'))
    const amount = scrollable.scrollLeft() + (this.scrollDistanceValue * direction)
    scrollable.animate({ scrollLeft: amount }, this.scrollSpeedValue)
  }
}
